export interface JwtVerificationResponse {
  customToken: string;
  user: {
    uid: string;
    email: string;
    role: string;
  };
}

export const verifyJwtAndGetCustomToken = async (
  token: string
): Promise<JwtVerificationResponse> => {
  const baseUrl = process.env.REACT_APP_FUNCTIONS_BASE_URL;
  if (!baseUrl) {
    throw new Error('REACT_APP_FUNCTIONS_BASE_URL non configuré');
  }

  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), 15000);

  try {
    const res = await fetch(`${baseUrl}/verifyJwtAndCreateToken`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
      signal: controller.signal,
    });

    if (!res.ok) {
      const body = await res.text().catch(() => '');
      const errorMsg = res.status === 401 ? 'Token invalide ou expiré' : body;
      throw new Error(`Vérification JWT échouée: ${res.status} ${errorMsg}`);
    }

    const data = (await res.json()) as JwtVerificationResponse;
    if (!data.customToken) {
      throw new Error('customToken manquant dans la réponse');
    }

    return data;
  } finally {
    window.clearTimeout(timeoutId);
  }
};
